import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useIntakeMedicalInfoUpdateLoading() {
  return useSelector(
    (state: RootState) => state.intakeQuestionnaire.updateMedicalInfoLoading,
  );
}
